<template lang="pug">
.related-movie-module
  .episode-title {{name}}
  slot
  .episode-list-wrap
    .second-title(v-t='"detailPage.relatedSeries"')
    vue-scroll(@handle-scroll="handleScroll" @handle-scroll-complete="handleComplete")
      .episode-list(v-if="list.length")
        nuxt-link.item(v-for="item in list" :key="item.id" :to="localePath('/detail/' + $semantic.type[item.category] + '/' + `${item.websiteParam||item.id}`)")
          img(:src="item.coverHorizontalUrl" alt="loklok movie recommend")
          p.title {{item.name}}
      fq-ignore(v-else)
</template>

<script>
export default {
  name: 'RelatedMovie',
  props: {
    name: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: []
    }
  },
  methods: {
    handleComplete() {
      console.log('scroll complete！')
    },
    handleScroll(vertical, horizontal, nativeEvent) {
      console.log('scroll')
    }
  }
}
</script>

<style scoped lang="sass">
.related-movie-module
  // padding-left: 20px
  // padding-right: 20px
  margin-bottom: 80px
  .episode-title
    max-height: 54px
    font-weight: 900
    font-size: 18px
    line-height: 150%
    color: $mainTextColor
    margin: 20px 22px 20px 20px
    @include ellipsis-multi(2)
  .episode-list-wrap
    width: 100%
    height: 450px
    padding: 0px 0px 20px 20px
  .second-title
    font-weight: bold
    font-size: 14px
    line-height: 120%
    color: $mainDescTextColor
    margin-bottom: 10px
  .episode-list
    width: 100%
    user-select: none
    padding-inline-start: 0
    @include base-flex
    flex-wrap: wrap
    margin-bottom: 28px
    .item
      line-height: 48px
      text-align: center
      font-size: 18px
      font-weight: 900
      color: #DEE4E9
      display: flex
      margin-bottom: 20px
      position: relative
      color: $mainTextColor
      &:hover
        color: $mainColor
      img
        width: 126px
        height: 70px
        border-radius: 8px
        margin-right: 20px
        background: $backgroundColor1
      .title
        font-size: 14px
        line-height: 150%
        font-weight: bold
        width: 194px
        height: 42px
        text-align: left
        word-break: break-all
        @include ellipsis-multi(2)
</style>
